import { render, staticRenderFns } from "./TournamentPrizePoolCard.vue?vue&type=template&id=1fb5cb36&scoped=true"
import script from "./TournamentPrizePoolCard.vue?vue&type=script&lang=js"
export * from "./TournamentPrizePoolCard.vue?vue&type=script&lang=js"
import style0 from "./TournamentPrizePoolCard.vue?vue&type=style&index=0&id=1fb5cb36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb5cb36",
  null
  
)

export default component.exports